import React from 'react';
import { Modal } from 'rsuite';
import GeneratedDocumentsTable from './GeneratedDocumentsTable';
import { GeneratedDocumentType } from '../../api/generateddocuments/generatedDocumentsApiTypes';

interface Props {
  open: boolean;
  onClose: () => void;
  type: GeneratedDocumentType;
}

const generatedDocumentTypeTitles: Record<GeneratedDocumentType, string> = {
  [GeneratedDocumentType.LISTING_REPORT_EXPORT]: 'Generated reports',
};

function getTitle(type: GeneratedDocumentType): string {
  return generatedDocumentTypeTitles[type] || 'documents';
}

export default function GeneratedDocumentsModal({ open, onClose, type }: Props) {
  const title = getTitle(type);

  return (
    <Modal open={open} onClose={() => onClose()} size="lg">
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {open && <GeneratedDocumentsTable type={type} />}
      </Modal.Body>
    </Modal>
  );
}
